<template>
  <div class="nd-indicator" :style="{ 'z-index': zIndex }">
    <div class="nd-indicator-content">
      <p>{{ title }}{{ ellipsis ? '...' : '' }}</p>
      <div class="nd-indicator-circle"></div>

      <div class="animation">
        <lottie class="animation"  ref="animataion" :options="defaultOptions" v-on:animCreated="handleAnimation"/>
      </div>
    </div>
  </div>
</template>
<script>
import popupManager from '../nd-popup-manager'
import Lottie from 'vue-lottie'
import animationData from './images/loading.json'

export default {
  name: 'nd-indicator',

  description: '加载中',
  components: {
    'lottie': Lottie
  },

  /**
   * @param title 加载说明
   * @param mask 是否打开遮罩
   * @param duration 持续时间，自动关闭 默认为0不会自己关闭
   */
  props: {
    title: {
      type: String,
      default: '加载中'
    },

    mask: {
      type: Boolean,
      default: false
    },

    duration: {
      type: Number,
      default: 0
    },

    ellipsis: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      closed: false,
      timer: null,
      closeHandler: null,
      seed: null,
      zIndex: 1000,
      maskInstance: null,
      defaultOptions: { animationData: animationData },
      animationSpeed: 1
    }
  },

  created () {
    if (this.mask) {
      this.maskInstance = this.$mask()
      this.maskInstance.open()
    }
    this.zIndex = popupManager.generateIndex()
  },

  mounted () {
    this.startTimer()
  },

  watch: {
    closed (newVal) {
      if (newVal) this.destroyElement()
    }
  },

  methods: {

    handleAnimation (anim) {
      this.anim = anim
    },

    close () {
      this.anim.stop()
      this.closed = true
      if (typeof this.closeHandler === 'function') {
        this.closeHandler(this.seed)
      }
    },

    destroyElement () {
      if (this.mask) {
        this.maskInstance.close()
      }
      this.$el.parentNode.removeChild(this.$el)
      this.$destroy(true)
    },

    startTimer () {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close()
          }
        }, this.duration)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .nd-indicator {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: transparent;

        .nd-indicator-content {
            padding-top: 60px;
            width: 280px;
            height: 280px;
            margin-left: -140px;
            margin-top: -140px;
            position: absolute;
            top: 50%;
            left: 50%;
            color: #fff;
            text-align: center;
            background-color: white;
            border-radius: 20px;
            box-shadow: 0px 20px 20px #eeeeee50;

            p {
                width: 100%;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                padding: 0 50px;
                color: #333333;
                position: absolute;
                top: 80%;
                left: 50%;
                transform: translate3d(-50%, -50%, 0);
            }
        }

        // .nd-indicator-circle {
        //     width: 100%;
        //     height: 100%;
        //     background-size: 100% 100%;
        //     animation: rotate 1s linear infinite;
        //     background-image: url(./images/circle.png);
        // }

        .animation {
            height: 110px;
            width: 70px;
            margin: 0 auto;
        }
    }

    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>